import Parse from "parse";
import { useMemo } from "react";
import { useTicketData } from "../..";

export const useTicketAssignment = () => {
  const ticketData = useTicketData();

  return useMemo(splitAssignmentTypes, [ticketData]);

  function splitAssignmentTypes() {
    const assignedRoles =
      ticketData.assignedTo?.filter((ass) => ass instanceof Parse.Role) ?? [];

    const assignedUsers =
      ticketData.assignedTo?.filter((ass) => ass instanceof Parse.User) ?? [];

    return { assignedRoles, assignedUsers };
  }
};
